(function() {
  const videos = document.querySelectorAll('.video');
  let lastScrollY = window.scrollY;

  const observer = new IntersectionObserver((entries) => { 
    const currentScrollY = window.scrollY;
    const scrollingDown = currentScrollY > lastScrollY;

    entries.forEach(entry => {
      const video = entry.target; 
      if (!(video instanceof HTMLVideoElement)) return;

      if (entry.isIntersecting) {
        if (scrollingDown) {
          // 向下滚进入视口：从头播放
          video.currentTime = 0;
        }
        const p = video.play();
        if (p && typeof p.catch === 'function') p.catch(() => { /* 忽略播放失败 */ });
      } else {
        // 离开视口时暂停（可按需删掉）
        video.pause();
      }
    });
    lastScrollY = currentScrollY;
  }, {
    threshold: 0.5
  });
  videos.forEach(v => observer.observe(v));
})()